var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"history-menu-view"},[_c('ly-tab',{attrs:{"items":_vm.menu,"options":_vm.options},on:{"change":_vm.onChange},model:{value:(_vm.selectedId),callback:function ($$v) {_vm.selectedId=$$v},expression:"selectedId"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }